export default __webpack_public_path__ + "static/media/MovieInfo-App.f2183421.png";